import { useQuery } from 'react-query';

import CompanyService from 'App/services/CompanyService';
import { errorHandler } from 'App/utils';

function useFetchCompanies(options) {
    return useQuery(['companies'], () => CompanyService.getAllCompanies(), {
        onError: errorHandler,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        ...options,
    });
}

export default useFetchCompanies;
